import { render, staticRenderFns } from "./storage.vue?vue&type=template&id=2f57b361&scoped=true"
import script from "./storage.vue?vue&type=script&lang=js"
export * from "./storage.vue?vue&type=script&lang=js"
import style0 from "./storage.vue?vue&type=style&index=0&id=2f57b361&prod&lang=scss&scoped=true"
import style1 from "./storage.vue?vue&type=style&index=1&id=2f57b361&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f57b361",
  null
  
)

export default component.exports